import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { IStyles } from '../../../theme'

const styles: IStyles = {
    title: {
        marginTop: 40,
    },
    switchWrapper: {
        display: 'flex',
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
}

addStyles(styles)
export default styles
